import React from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";

export default function YelpLanding() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black text-white">
      <Navigation />

      <div className="max-w-3xl mx-auto px-4 py-20 text-center">
        {/* Yelp badge */}
        <div className="inline-flex items-center gap-2 bg-red-900/30 border border-red-700/50 rounded-full px-4 py-2 text-sm text-red-400 mb-8">
          <span>⭐</span> Found us on Yelp
        </div>

        <h1 className="text-4xl md:text-5xl font-bold mb-6">
          Submit Your Project Request<br/>
          <span className="text-orange-500">Trusted Local Contractor</span>
        </h1>

        <p className="text-zinc-400 text-lg mb-10 max-w-xl mx-auto">
          Tell us what you need — roofing, solar, landscaping, HVAC, plumbing, or electrical — and we'll match you with a licensed pro in your ZIP code. Free, fast, no pressure.
        </p>

        <button
          onClick={() => navigate("/")}
          className="bg-orange-600 hover:bg-orange-700 text-white font-bold text-lg px-10 py-4 rounded-xl mb-6 transition"
        >
          Submit Project Request →
        </button>

        <p className="text-zinc-500 text-sm">Takes 2 minutes. No spam, no obligation.</p>

        <div className="grid grid-cols-3 gap-4 mt-16">
          {[
            { emoji: "🏠", label: "Roofing" },
            { emoji: "☀️", label: "Solar" },
            { emoji: "🌿", label: "Landscaping" },
            { emoji: "❄️", label: "HVAC" },
            { emoji: "🔧", label: "Plumbing" },
            { emoji: "⚡", label: "Electrical" },
          ].map(({ emoji, label }) => (
            <div key={label} className="bg-zinc-900 rounded-xl p-4 text-center">
              <div className="text-2xl mb-1">{emoji}</div>
              <div className="text-sm text-zinc-300">{label}</div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-zinc-900 rounded-2xl p-8 text-left">
          <h2 className="text-xl font-bold mb-4">Why BuildBright?</h2>
          <ul className="space-y-3 text-zinc-300">
            <li className="flex items-start gap-3"><span className="text-orange-400 mt-0.5">✓</span> Available local contractors</li>
            <li className="flex items-start gap-3"><span className="text-orange-400 mt-0.5">✓</span> Matched by your exact ZIP code</li>
            <li className="flex items-start gap-3"><span className="text-orange-400 mt-0.5">✓</span> Get up to 3 competing quotes</li>
            <li className="flex items-start gap-3"><span className="text-orange-400 mt-0.5">✓</span> 100% free for homeowners</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
